(() => {
  class BekRoofConfigurator {
    constructor(root) {
      this.root = root;
      this.step = 1;
      this.totalSteps = 7;
      this.basePrice = 5190;
      this.currentConfigSystem = null;
      this.baseQuote = null;
      this.mountingQuote = null;
      this.ledQuote = null;
      this.staticsQuote = null;
      this.frontQuote = null;
      this.leftQuote = null;
      this.rightQuote = null;
      this.productEngine = window.BEKProductEngine && window.BEK_PRODUCT_DATA
        ? new window.BEKProductEngine(window.BEK_PRODUCT_DATA, {
            priceMode: root.dataset.priceMode || 'vd_list_round90',
            dealerDiscountPct: Number(root.dataset.dealerDiscountPct || 50),
            vatPct: Number(root.dataset.vatPct || 19),
            targetMarginPct: Number(root.dataset.targetMarginPct || 41),
            skyviewPriceMode: root.dataset.skyviewPriceMode || 'vd_list_round90',
            skyviewDealerDiscountPct: Number(root.dataset.skyviewDealerDiscountPct || 50),
            skyviewTargetMarginPct: Number(root.dataset.skyviewTargetMarginPct || 40),
            sg23DealerDiscountPct: Number(root.dataset.sg23DealerDiscountPct || 50),
            fr23DealerDiscountPct: Number(root.dataset.fr23DealerDiscountPct || 50),
            wedgeGlassDealerDiscountPct: Number(root.dataset.wedgeGlassDealerDiscountPct || 50),
            roundingMode: root.dataset.roundingMode || 'x090',
            mountingDealerDiscountPct: Number(root.dataset.mountingDealerDiscountPct || 50),
            mountingSurcharge6000: Number(root.dataset.mountingSurcharge6000 || 1290),
            mountingSurcharge7000: Number(root.dataset.mountingSurcharge7000 || 1490),
            mountingSurcharge8000: Number(root.dataset.mountingSurcharge8000 || 1690),
            mountingSurcharge9000: Number(root.dataset.mountingSurcharge9000 || 1790),
            mountingSurcharge10000: Number(root.dataset.mountingSurcharge10000 || 1890),
            mountingSurcharge11000: Number(root.dataset.mountingSurcharge11000 || 1990),
            mountingSurcharge12000: Number(root.dataset.mountingSurcharge12000 || 2090),
            mountingCombo6000: Number(root.dataset.mountingCombo6000 || 2490),
            mountingComboDiscountPctAbove6: Number(root.dataset.mountingComboDiscountPctAbove6 || 0),
            ledDealerDiscountPct: Number(root.dataset.ledDealerDiscountPct || 0),
            ledGross6: Number(root.dataset.ledGross6 || 149),
            ledGross8: Number(root.dataset.ledGross8 || 179),
            ledGross6wifi: Number(root.dataset.ledGross6wifi || 179),
            ledGross12wifi: Number(root.dataset.ledGross12wifi || 269),
            staticsDealerDiscountPct: Number(root.dataset.staticsDealerDiscountPct || 0),
            staticsGrossCalculation: Number(root.dataset.staticsGrossCalculation || 249),
            staticsGrossStamp: Number(root.dataset.staticsGrossStamp || 990),
            sg23PriceMode: root.dataset.sg23PriceMode || 'approved_prices',
            sg23TargetMarginPct: Number(root.dataset.sg23TargetMarginPct || 41),
            sg23Gross3000: Number(root.dataset.sg23Gross3000 || 1890),
            sg23Gross4000: Number(root.dataset.sg23Gross4000 || 2490),
            sg23Gross5000: Number(root.dataset.sg23Gross5000 || 3190),
            sg23Gross6000: Number(root.dataset.sg23Gross6000 || 3590),
            fr23PriceMode: root.dataset.fr23PriceMode || 'vd_list_rounding',
            fr23TargetMarginPct: Number(root.dataset.fr23TargetMarginPct || 41),
            fr23StandaloneMinContributionNet: Number(root.dataset.fr23StandaloneMinContributionNet || 250)
          })
        : null;
      this.locale = root.dataset.locale || 'de-DE';
      this.currency = root.dataset.currency || 'EUR';
      this.orderBridgeEnabled = root.dataset.orderBridgeEnabled === 'true';
      this.orderBridgeEndpoint = (root.dataset.orderBridgeEndpoint || '').trim();
      this.orderButtonLabel = root.dataset.orderButtonLabel || 'Jetzt sicher bestellen';
      this.currentConfigId = null;
      this.lastPayload = null;
      this.measurementsTouched = false;
      this.nextLabels = {
        1: 'Weiter zur Montageart →',
        2: 'Weiter zu Farbe & Dachdeckung →',
        3: 'Weiter zur Ausstattung →',
        4: 'Weiter zu Seitenwänden →',
        5: 'Weiter zur Prüfung →',
        6: 'Weiter zur Zusammenfassung →',
        7: 'Zusammenfassung'
      };
      this.bind();
      this.render();
    }

    bind() {
      this.root.addEventListener('click', (event) => {
        const next = event.target.closest('[data-bek-next]');
        const prev = event.target.closest('[data-bek-prev]');
        const jump = event.target.closest('[data-bek-jump]');
        const sideZone = event.target.closest('[data-side-zone]');
        const save = event.target.closest('[data-bek-save]');
        const order = event.target.closest('[data-bek-order]');

        if (save) { event.preventDefault(); this.saveConfiguration(); return; }
        if (order) { event.preventDefault(); this.submitOrderBridge(order); return; }
        if (next) this.go(this.step + 1);
        if (prev) this.go(this.step - 1);
        if (jump) this.go(Number(jump.dataset.bekJump));
        if (sideZone) {
          const id = sideZone.dataset.sideZone;
          const input = this.root.querySelector(`[data-side-input="${id}"]`);
          if (input) {
            input.checked = !input.checked;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });

      this.root.addEventListener('change', (event) => {
        if (event.target.matches('[name="roof_system"]')) {
          this.currentConfigId = null;
          this.currentConfigSystem = null;
          // Keep the first impression useful without overwriting dimensions the customer already edited.
          if (!this.measurementsTouched) {
            const depth = this.root.querySelector('[name="depth"]');
            if (depth) depth.value = event.target.value === 'SKYVIEW' ? '3500' : '4000';
          }
          this.syncSystemUi();
        }
        if (event.target.matches('[name="mounting_combo"]')) {
          if (event.target.checked) {
            const free = this.root.querySelector('[name="mounting"][value="freestanding"]');
            if (free) free.checked = true;
          }
        } else if (event.target.matches('[name="mounting"]')) {
          const combo = this.root.querySelector('[name="mounting_combo"]');
          if (combo && event.target.value !== 'freestanding') combo.checked = false;
        }

        if (event.target.matches('input, select')) this.render();
        if (event.target.matches('[data-bek-upload]')) this.updateUploadStatus(event.target);
        if (event.target.matches('[data-bek-photo-input]')) this.updatePhotoCard(event.target);
      });

      this.root.addEventListener('input', (event) => {
        if (event.target.matches('[name="width"], [name="depth"]')) { this.measurementsTouched = true; this.validateMeasurements(false); }
        if (event.target.matches('[data-summary-source], [name="sg_height"], [name="wedge_low"], [name="wedge_high"]')) this.render();
      });
    }

    go(step) {
      const target = Math.min(this.totalSteps, Math.max(1, step));
      if (target > this.step && this.step === 1 && !this.validateMeasurements(true)) return;

      this.step = target;
      this.render();
      const top = this.root.getBoundingClientRect().top + window.scrollY - 92;
      window.scrollTo({ top, behavior: 'smooth' });
    }

    validateMeasurements(focusError = false) {
      const rules = this.measurementRules();
      let valid = true;
      let firstInvalid = null;

      Object.entries(rules).forEach(([name, rule]) => {
        const input = this.root.querySelector(`[name="${name}"]`);
        const error = this.root.querySelector(`[data-field-error="${name}"]`);
        if (error) error.textContent = `Bitte geben Sie ${name === 'width' ? 'eine Breite' : 'eine Tiefe'} zwischen ${this.formatMm(rule.min)} und ${this.formatMm(rule.max)} mm ein.`;
        const value = Number(input?.value);
        const isValid = Boolean(input) && Number.isFinite(value) && value >= rule.min && value <= rule.max;
        if (input) input.setAttribute('aria-invalid', isValid ? 'false' : 'true');
        if (error) error.hidden = isValid;
        if (!isValid) {
          valid = false;
          if (!firstInvalid) firstInvalid = input;
        }
      });

      if (!valid && focusError && firstInvalid) firstInvalid.focus({ preventScroll: true });
      return valid;
    }

    selectedLabel(name, fallback = '') {
      const el = this.root.querySelector(`[name="${name}"]:checked`);
      return el ? (el.dataset.label || el.value) : fallback;
    }

    selectedPrice(name) {
      const el = this.root.querySelector(`[name="${name}"]:checked`);
      return Number(el?.dataset.price || 0);
    }

    inputValue(name, fallback = '') {
      const el = this.root.querySelector(`[name="${name}"]`);
      return el && el.value ? el.value : fallback;
    }

    currentProductCode() {
      return String(this.root.querySelector('[name="roof_system"]:checked')?.value || 'TDS').toUpperCase();
    }

    isSkyView() {
      return this.currentProductCode() === 'SKYVIEW';
    }

    productMeta(code = this.currentProductCode()) {
      return code === 'SKYVIEW'
        ? { code: 'SKYVIEW', name: 'SkyView kubisches Terrassendach', short: 'SkyView', roofLabel: 'Kubisches Dach' }
        : { code: 'TDS', name: 'TDS Terrassendach', short: 'TDS', roofLabel: 'Klassisches Pultdach' };
    }

    measurementRules() {
      return this.isSkyView()
        ? { width: { min: 1000, max: 14000 }, depth: { min: 500, max: 7000 } }
        : { width: { min: 2000, max: 12000 }, depth: { min: 1500, max: 4500 } };
    }

    blockingTechnicalFlags() {
      if (!this.isSkyView()) return [];
      const blocking = new Set(['SKYVIEW_RAFTER_CORE_REQUIRED_NOT_PRICED', 'SKYVIEW_GUTTER_CORE_REQUIRED_NOT_PRICED']);
      return (this.baseQuote?.flags || []).filter((flag) => blocking.has(flag.code));
    }

    syncSystemUi() {
      const isSky = this.isSkyView();
      const meta = this.productMeta();
      this.root.dataset.activeProduct = meta.code;
      this.root.classList.toggle('is-skyview', isSky);
      this.root.classList.toggle('is-tds', !isSky);

      // The current VD SkyView matrix is a wall-mounted matrix. Unpriced additional
      // statics for freestanding / overhang variants are deliberately not sold online.
      const wall = this.root.querySelector('[name="mounting"][value="wall"]');
      const combo = this.root.querySelector('[name="mounting_combo"]');
      this.root.querySelectorAll('[name="mounting"]').forEach((input) => {
        const blocked = isSky && input.value !== 'wall';
        input.disabled = blocked;
        input.closest('.bek-choice')?.classList.toggle('is-disabled', blocked);
      });
      if (isSky && wall) wall.checked = true;
      if (combo) {
        combo.disabled = isSky;
        if (isSky) combo.checked = false;
        combo.closest('.bek-choice')?.classList.toggle('is-disabled', isSky);
      }

      // TDS and SkyView both support VSG clear/matt plus the four VD polycarbonate variants.
      this.root.querySelectorAll('[data-cover-systems]').forEach((el) => {
        const systems = String(el.dataset.coverSystems || '').split(',').map((x) => x.trim().toUpperCase());
        const show = systems.includes(meta.code);
        el.hidden = !show;
        const input = el.querySelector('input[name="glass"]');
        if (input) input.disabled = !show;
      });
      const selectedCover = this.root.querySelector('[name="glass"]:checked');
      if (selectedCover?.disabled) {
        const fallback = this.root.querySelector('[name="glass"][value="clear"]');
        if (fallback) fallback.checked = true;
      }

      this.root.querySelectorAll('[data-tds-only]').forEach((el) => { el.hidden = isSky; });
      this.root.querySelectorAll('[data-skyview-only]').forEach((el) => { el.hidden = !isSky; });
      this.root.querySelectorAll('[data-product-name]').forEach((el) => { el.textContent = meta.name; });
      this.root.querySelectorAll('[data-product-short]').forEach((el) => { el.textContent = meta.short; });
      this.root.querySelectorAll('[data-roof-label]').forEach((el) => { el.textContent = meta.roofLabel; });
      this.root.querySelectorAll('[data-summary-product-image]').forEach((img) => {
        img.hidden = String(img.dataset.summaryProductImage || '').toUpperCase() !== meta.code;
      });

      const mountIntro = this.root.querySelector('[data-mounting-intro]');
      if (mountIntro) mountIntro.textContent = isSky
        ? 'SkyView wird in der aktuellen VD-Preismatrix als Wandmontage kalkuliert. Freistehende Varianten benötigen zusätzliche Statikbauteile und werden erst nach technischer Prüfung angeboten.'
        : 'Wählen Sie die Grundkonstruktion. Aufpreis und benötigte Statikträger, Blenden und Zusatzpfosten werden automatisch aus Ihrer Breite berechnet.';

      const sideIntro = this.root.querySelector('[data-side-intro]');
      if (sideIntro) sideIntro.textContent = isSky
        ? 'Wählen Sie eine oder mehrere Seiten über die drei Karten aus. SkyView nutzt die Pfostenanzahl aus der VD-Dachmatrix für die Frontaufteilung; links und rechts werden ohne FR23-Keil kalkuliert.'
        : 'Wählen Sie eine oder mehrere Seiten über die drei Karten aus. SG23 und FR23 werden aus den echten VD-Preisstaffeln berechnet; die TDS-Front wird automatisch nach der tatsächlichen Pfostenlogik geteilt.';

      const leftText = this.root.querySelector('[data-side-left-text]');
      const rightText = this.root.querySelector('[data-side-right-text]');
      if (leftText) leftText.textContent = isSky ? 'SG23 Glasschiebewand nach Maß – beim kubischen SkyView ohne zusätzlichen FR23-Keil.' : 'SG23 Glasschiebewand + passender FR23-Glaskeil + VSG-Verglasung.';
      if (rightText) rightText.textContent = isSky ? 'SG23 Glasschiebewand nach Maß – beim kubischen SkyView ohne zusätzlichen FR23-Keil.' : 'SG23 Glasschiebewand + passender FR23-Glaskeil + VSG-Verglasung.';

      const width = this.root.querySelector('[name="width"]');
      const depth = this.root.querySelector('[name="depth"]');
      const rules = this.measurementRules();
      if (width) { width.min = String(rules.width.min); width.max = String(rules.width.max); }
      if (depth) { depth.min = String(rules.depth.min); depth.max = String(rules.depth.max); }
      const widthHelp = this.root.querySelector('[data-width-help]');
      const depthHelp = this.root.querySelector('[data-depth-help]');
      if (widthHelp) widthHelp.textContent = `Mindestens ${this.formatMm(rules.width.min)} mm, maximal ${this.formatMm(rules.width.max)} mm`;
      if (depthHelp) depthHelp.textContent = `Mindestens ${this.formatMm(rules.depth.min)} mm, maximal ${this.formatMm(rules.depth.max)} mm`;
    }

    price() {
      let price = this.basePrice + Number(this.mountingQuote?.customerGrossSurcharge || 0);
      price += Number(this.ledQuote?.customerGrossSurcharge || 0);
      price += Number(this.staticsQuote?.customerGrossSurcharge || 0);

      const front = this.root.querySelector('[data-side-input="front"]');
      const left = this.root.querySelector('[data-side-input="left"]');
      const right = this.root.querySelector('[data-side-input="right"]');
      if (front?.checked && this.frontQuote?.ok) price += Number(this.frontQuote.customerGross || 0);
      if (left?.checked && this.leftQuote?.ok) price += Number(this.leftQuote.customerGross || 0);
      if (right?.checked && this.rightQuote?.ok) price += Number(this.rightQuote.customerGross || 0);

      return Math.max(0, price);
    }

    formatPrice(value) {
      return new Intl.NumberFormat(this.locale, {
        style: 'currency', currency: this.currency, maximumFractionDigits: 0
      }).format(value);
    }

    formatMoney2(value) {
      return new Intl.NumberFormat(this.locale, {
        style: 'currency', currency: this.currency, minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format(Number(value || 0));
    }

    formatNumber(value, digits = 2) {
      return new Intl.NumberFormat(this.locale, {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
      }).format(Number(value || 0));
    }

    setText(selector, text) {
      this.root.querySelectorAll(selector).forEach((el) => { el.textContent = text; });
    }

    render() {
      this.syncSystemUi();
      const product = this.productMeta();
      const isSky = product.code === 'SKYVIEW';

      this.root.querySelectorAll('[data-bek-step]').forEach((el) => {
        const active = Number(el.dataset.bekStep) === this.step;
        el.classList.toggle('is-active', active);
        el.hidden = !active;
      });

      this.root.querySelectorAll('[data-progress-step]').forEach((el) => {
        const n = Number(el.dataset.progressStep);
        el.classList.toggle('is-active', n === this.step);
        el.classList.toggle('is-complete', n < this.step);
        if (n === this.step) el.setAttribute('aria-current', 'step');
        else el.removeAttribute('aria-current');
      });

      const width = this.inputValue('width', '6000');
      const depth = this.inputValue('depth', isSky ? '3500' : '4000');
      const mountingInput = this.root.querySelector('[name="mounting"]:checked');
      const mountingValue = mountingInput?.value || 'wall';
      const mountingBase = this.selectedLabel('mounting', 'Wandmontage');
      const combo = isSky ? false : Boolean(this.root.querySelector('[name="mounting_combo"]:checked'));
      const mounting = combo ? 'Freistehend + Dachüberstand' : mountingBase;
      const color = this.selectedLabel('color', 'RAL 7016 Anthrazit');
      const colorValue = this.root.querySelector('[name="color"]:checked')?.value || '7016';
      const cover = this.selectedLabel('glass', 'VSG 8 mm klar');
      const coverValue = this.root.querySelector('[name="glass"]:checked')?.value || 'clear';
      const ledInput = this.root.querySelector('[name="led"]:checked');
      const staticsInput = this.root.querySelector('[name="statics"]:checked');
      const ledValue = ledInput?.value || 'none';
      const staticsValue = staticsInput?.value || 'simple';
      const led = this.selectedLabel('led', 'Ohne LED');
      const statics = this.selectedLabel('statics', 'Vereinfachter Nachweis');

      this.baseQuote = this.calculateBaseQuote(width, depth, coverValue);
      this.basePrice = this.baseQuote?.ok ? Number(this.baseQuote.customerGross || 0) : 0;
      this.mountingQuote = this.calculateMountingQuote(width, mountingValue, combo);
      this.ledQuote = this.calculateEquipmentQuote('led', ledValue);
      this.staticsQuote = this.calculateEquipmentQuote('statics', staticsValue);

      const sgHeight = Number(this.inputValue('sg_height', this.root.dataset.sg23DefaultHeight || '2300'));
      const sgGlassValue = this.root.querySelector('[name="sg_glass"]:checked')?.value || 'clear';
      const wedgeLowRaw = this.inputValue('wedge_low', '');
      const wedgeHighRaw = this.inputValue('wedge_high', '');
      const wedgeLow = wedgeLowRaw === '' ? null : Number(wedgeLowRaw);
      const wedgeHigh = wedgeHighRaw === '' ? null : Number(wedgeHighRaw);

      this.frontQuote = this.calculateSg23Quote(width, sgHeight, sgGlassValue);
      // FR23 side-wall wedges are VSG products. A polycarbonate roof therefore uses
      // clear VSG for the wedge unless a dedicated wedge-glass choice is introduced later.
      const wedgeGlassValue = ['clear', 'matt'].includes(coverValue) ? coverValue : 'clear';
      this.leftQuote = this.calculateSideWallQuote(depth, sgHeight, sgGlassValue, wedgeLow, wedgeHigh, wedgeGlassValue);
      this.rightQuote = this.calculateSideWallQuote(depth, sgHeight, sgGlassValue, wedgeLow, wedgeHigh, wedgeGlassValue);

      this.renderMountingPrices(width);
      this.renderEquipmentPrices();
      this.renderSideWallPrices();

      const priceText = this.formatPrice(this.price());
      const widthText = `${this.formatMm(width)} mm`;
      const depthText = `${this.formatMm(depth)} mm`;

      this.setText('[data-summary-product]', product.name);
      this.setText('[data-review-product]', product.name);
      this.setText('[data-summary-roof-form]', product.roofLabel);
      this.setText('[data-summary-dimensions]', `${this.formatMm(width)} × ${this.formatMm(depth)} mm`);
      this.setText('[data-summary-width]', widthText);
      this.setText('[data-summary-depth]', depthText);
      this.setText('[data-summary-mounting]', mounting);
      this.setText('[data-summary-color]', color);
      this.setText('[data-summary-glass]', cover);
      this.setText('[data-summary-led]', led);
      this.setText('[data-summary-statics]', statics);
      this.setText('[data-live-price]', priceText);
      this.setText('[data-current-step]', String(this.step));
      this.setText('[data-width-visual]', widthText);
      this.setText('[data-depth-visual]', depthText);

      ['front', 'left', 'right'].forEach((side) => {
        const input = this.root.querySelector(`[data-side-input="${side}"]`);
        const zone = this.root.querySelector(`[data-side-zone="${side}"]`);
        const card = this.root.querySelector(`[data-side-card="${side}"]`);
        if (zone && input) zone.classList.toggle('is-selected', input.checked);
        if (card && input) card.classList.toggle('is-selected', input.checked);
      });

      const sides = [];
      const front = this.root.querySelector('[data-side-input="front"]');
      const left = this.root.querySelector('[data-side-input="left"]');
      const right = this.root.querySelector('[data-side-input="right"]');
      const frontFields = Number(this.frontQuote?.fieldCount || 1);
      if (front?.checked) sides.push(frontFields > 1 ? `Front SG23 (${frontFields} Felder)` : 'Front SG23');

      const frontZone = this.root.querySelector('[data-side-zone="front"]');
      if (frontZone) frontZone.classList.toggle('is-two-fields', frontFields > 1);
      this.setText('[data-side-front-title]', frontFields > 1 ? `Front mit ${frontFields} Glasschiebewänden` : 'Front mit Glasschiebewand');
      this.setText('[data-review-front-label]', frontFields > 1 ? `Front Glasschiebewände (${frontFields} Felder)` : 'Front Glasschiebewand');
      if (left?.checked) sides.push(isSky ? 'Links SG23' : 'Links komplett');
      if (right?.checked) sides.push(isSky ? 'Rechts SG23' : 'Rechts komplett');
      this.setText('[data-review-left-label]', isSky ? 'Linke Glasschiebewand' : 'Linke Seite komplett');
      this.setText('[data-review-right-label]', isSky ? 'Rechte Glasschiebewand' : 'Rechte Seite komplett');
      this.setText('[data-summary-sides]', sides.length ? sides.join(', ') : 'Keine Seitenwände');

      const hasPendingFrontPrice = Boolean(front?.checked && !this.frontQuote?.ok);
      const hasPendingLeftPrice = Boolean(left?.checked && !this.leftQuote?.ok);
      const hasPendingRightPrice = Boolean(right?.checked && !this.rightQuote?.ok);
      const hasPendingSidePrice = hasPendingFrontPrice || hasPendingLeftPrice || hasPendingRightPrice;

      const wedgeInputs = this.root.querySelector('[data-wedge-inputs]');
      if (wedgeInputs) wedgeInputs.hidden = isSky || !(left?.checked || right?.checked);

      const technicalFlags = this.blockingTechnicalFlags();
      const technicalBlocked = technicalFlags.length > 0;
      const technicalWarning = this.root.querySelector('[data-technical-review-warning]');
      if (technicalWarning) {
        technicalWarning.hidden = !technicalBlocked;
        if (technicalBlocked) technicalWarning.textContent = `Technische Prüfung erforderlich: ${technicalFlags.map((f) => f.message).join(' ')}`;
      }

      this.root.querySelectorAll('[data-price-note]').forEach((el) => {
        el.textContent = technicalBlocked
          ? 'inkl. 19 % MwSt. · technische Prüfung vor Bestellung erforderlich · kostenlose Lieferung'
          : (hasPendingSidePrice
            ? 'inkl. 19 % MwSt. · mindestens eine Seitenwand ist noch nicht vollständig bepreist · kostenlose Lieferung'
            : 'inkl. 19 % MwSt. · kostenlose Lieferung');
      });

      this.renderEngineDebug(this.baseQuote, this.mountingQuote, this.ledQuote, this.staticsQuote, {
        front: this.frontQuote,
        left: this.leftQuote,
        right: this.rightQuote
      });

      const nextLabel = this.nextLabels[this.step] || 'Weiter →';
      this.root.querySelectorAll('[data-sidebar-next]').forEach((button) => {
        button.textContent = nextLabel;
        button.disabled = this.step >= this.totalSteps;
      });
      this.root.querySelectorAll('.bek-mobile-pricebar [data-bek-next]').forEach((button) => {
        button.textContent = this.step >= this.totalSteps ? 'Fertig' : 'Weiter →';
        button.disabled = this.step >= this.totalSteps;
      });

      const mountingPrice = Number(this.mountingQuote?.customerGrossSurcharge || 0);
      const ledPrice = Number(this.ledQuote?.customerGrossSurcharge || 0);
      const staticsPrice = Number(this.staticsQuote?.customerGrossSurcharge || 0);
      const frontPrice = front?.checked && this.frontQuote?.ok ? Number(this.frontQuote.customerGross || 0) : 0;
      const leftPrice = left?.checked && this.leftQuote?.ok ? Number(this.leftQuote.customerGross || 0) : 0;
      const rightPrice = right?.checked && this.rightQuote?.ok ? Number(this.rightQuote.customerGross || 0) : 0;
      const reviewData = {
        productCode: product.code, productName: product.name, roofForm: product.roofLabel,
        width, depth, mounting, mountingValue, combo, color, colorValue, glass: cover, glassValue: coverValue, led, ledValue, statics, staticsValue, sides, priceText,
        mountingPrice, ledPrice, staticsPrice, frontPrice, leftPrice, rightPrice,
        frontSelected: Boolean(front?.checked), leftSelected: Boolean(left?.checked), rightSelected: Boolean(right?.checked),
        frontPending: hasPendingFrontPrice, leftPending: hasPendingLeftPrice, rightPending: hasPendingRightPrice,
        hasPendingSidePrice, sgHeight, sgGlassValue, wedgeLow, wedgeHigh, technicalBlocked, technicalFlags
      };
      this.renderReview(reviewData);
      this.lastPayload = this.buildConfigurationPayload(reviewData);
      this.renderOrderBridgeState();
    }

    calculateBaseQuote(width, depth, coverValue) {
      if (!this.productEngine) return { ok: false, error: 'PRODUCT_ENGINE_NOT_AVAILABLE' };
      return this.isSkyView()
        ? this.productEngine.calculateSkyView({ width, depth, cover: coverValue })
        : this.productEngine.calculateTds({ width, depth, glass: coverValue });
    }

    calculateMountingQuote(width, mode, combo) {
      if (!this.productEngine) return { ok: false, error: 'PRODUCT_ENGINE_NOT_AVAILABLE' };
      if (this.isSkyView()) {
        if (mode !== 'wall' || combo) return { ok: false, error: 'SKYVIEW_MOUNTING_TECHNICAL_REVIEW' };
        return { ok: true, mode: 'wall', label: 'Wandmontage', combo: false, widthMm: Number(width), customerGrossSurcharge: 0, vdListNet: 0, bekEkNet: 0, customerNet: 0, grossProfitNet: 0, rawMarginPct: 0, quantity: { constructionRuns: 0, beamPieces: 0, beamTotalM: 0, fasciaTotalM: 0, posts: 0, postTotalM: 0 }, components: [], flags: [] };
      }
      return this.productEngine.calculateMountingConstruction({ width, mode, combo });
    }

    calculateEquipmentQuote(category, value) {
      if (!this.productEngine) return { ok: false, error: 'PRODUCT_ENGINE_NOT_AVAILABLE' };
      return this.productEngine.calculateEquipmentOption({ category, value });
    }

    calculateSg23Quote(width, height, glass) {
      if (!this.productEngine) return { ok: false, error: 'PRODUCT_ENGINE_NOT_AVAILABLE' };
      if (this.isSkyView()) {
        return this.productEngine.calculateSkyViewFrontWall({
          roofWidth: width,
          postCount: Number(this.baseQuote?.supportCount || 0),
          sgHeight: height,
          sgGlass: glass
        });
      }
      return this.productEngine.calculateTdsFrontWall({ roofWidth: width, sgHeight: height, sgGlass: glass });
    }

    calculateSideWallQuote(width, sgHeight, sgGlass, wedgeLow, wedgeHigh, wedgeGlass) {
      if (!this.productEngine) return { ok: false, error: 'PRODUCT_ENGINE_NOT_AVAILABLE' };
      if (this.isSkyView()) return this.productEngine.calculateSkyViewSideWall({ width, sgHeight, sgGlass });
      return this.productEngine.calculateTdsSideWall({
        width,
        sgHeight,
        sgGlass,
        wedgeLow,
        wedgeHigh,
        wedgeGlass
      });
    }

    sideQuoteLabel(quote, isCompleteSide = false) {
      if (quote?.ok) return `+${this.formatPrice(quote.customerGross)}`;
      if (isCompleteSide && quote?.partialCustomerGross) return `ab ${this.formatPrice(quote.partialCustomerGross)} + Keil`;
      if (quote?.error === 'SG23_AUTO_LAYOUT_NOT_AVAILABLE' || quote?.error === 'SG23_OUTSIDE_VARIANT_MATRIX') return 'Teilung prüfen';
      if (quote?.error === 'SG23_HEIGHT_EXCEEDS_LIMIT') return 'Höhe prüfen';
      if (quote?.error === 'WEDGE_HEIGHTS_REQUIRED') return 'Keilmaße eingeben';
      return 'Preis prüfen';
    }

    renderSideWallPrices() {
      const isSky = this.isSkyView();
      this.setText('[data-side-price="front"]', this.sideQuoteLabel(this.frontQuote, false));
      this.setText('[data-side-price="left"]', this.sideQuoteLabel(this.leftQuote, !isSky));
      this.setText('[data-side-price="right"]', this.sideQuoteLabel(this.rightQuote, !isSky));

      const sgHeight = this.inputValue('sg_height', this.root.dataset.sg23DefaultHeight || '2300');
      this.setText('[data-side-sg-height-label]', `${this.formatMm(sgHeight)} mm`);

      const frontDetail = this.root.querySelector('[data-side-front-detail]');
      if (frontDetail) {
        frontDetail.textContent = this.frontQuote?.ok
          ? (this.frontQuote.fieldCount > 1
              ? `${this.frontQuote.fieldCount} getrennte Felder zwischen ${this.frontQuote.postCount} Pfosten · lichte Feldbreite je ca. ${this.formatMm(Math.round(this.frontQuote.fieldWidthMm))} mm · je ${this.frontQuote.fieldQuote.layoutLabel} · Preisstaffel ${this.formatMm(this.frontQuote.fieldQuote.widthBand)} × ${this.formatMm(this.frontQuote.fieldQuote.heightBand)} mm`
              : `1 Feld zwischen ${this.frontQuote.postCount} Pfosten · lichte Breite ca. ${this.formatMm(Math.round(this.frontQuote.fieldWidthMm))} mm · ${this.frontQuote.fieldQuote.layoutLabel} · Preisstaffel ${this.formatMm(this.frontQuote.fieldQuote.widthBand)} × ${this.formatMm(this.frontQuote.fieldQuote.heightBand)} mm`)
          : (isSky ? 'Frontaufteilung wird automatisch anhand der SkyView-Pfosten aus der VD-Dachmatrix berechnet.' : 'Frontaufteilung wird automatisch anhand der TDS-Pfosten berechnet.');
      }

      const sideDetail = this.root.querySelector('[data-side-complete-detail]');
      if (sideDetail) {
        if (isSky) {
          const side = this.leftQuote?.ok ? this.leftQuote : this.rightQuote?.ok ? this.rightQuote : null;
          sideDetail.textContent = side?.sg23?.ok
            ? `${side.sg23.layoutLabel} · ${this.formatPrice(side.customerGross)} · kein FR23-Keil beim kubischen SkyView erforderlich.`
            : 'SkyView Seitenwand wird als SG23 ohne FR23-Keil nach der gewählten Tiefe berechnet.';
        } else if (this.leftQuote?.ok) {
          sideDetail.textContent = `${this.leftQuote.sg23.layoutLabel} + ${this.leftQuote.wedge.layoutLabel} · Keilglas ${this.leftQuote.wedge.glassAreaSqm.toFixed(2).replace('.', ',')} m²`;
        } else if (this.leftQuote?.partialCustomerGross) {
          sideDetail.textContent = `SG23 ab ${this.formatPrice(this.leftQuote.partialCustomerGross)}; für den Endpreis noch beide Keilhöhen eingeben.`;
        } else {
          sideDetail.textContent = 'SG23 + FR23-Keil werden automatisch nach Ihren Maßen berechnet.';
        }
      }
    }

    renderEquipmentPrices() {
      ['none', '6', '8', '6wifi', '12wifi'].forEach((value) => {
        const q = this.calculateEquipmentQuote('led', value);
        const el = this.root.querySelector(`[data-led-option-price="${value}"]`);
        if (el && q?.ok) el.textContent = q.customerGrossSurcharge ? `+${this.formatPrice(q.customerGrossSurcharge)}` : 'inklusive';
      });
      ['simple', 'calculation', 'stamp'].forEach((value) => {
        const q = this.calculateEquipmentQuote('statics', value);
        const el = this.root.querySelector(`[data-statics-option-price="${value}"]`);
        if (el && q?.ok) el.textContent = q.customerGrossSurcharge ? `+${this.formatPrice(q.customerGrossSurcharge)}` : 'inklusive';
      });
    }

    renderMountingPrices(width) {
      if (this.isSkyView()) {
        this.setText('[data-mounting-price="freestanding"]', 'Technische Prüfung');
        this.setText('[data-mounting-price="overhang"]', 'Technische Prüfung');
        this.setText('[data-mounting-price="combo"]', 'Technische Prüfung');
        const detail = this.root.querySelector('[data-mounting-technical]');
        if (detail) {
          detail.hidden = false;
          detail.textContent = 'SkyView wird online aktuell als Wandmontage kalkuliert. Freistehende Konstruktionen benötigen laut VD zusätzliche StatikSparren und Stützen, deren zentrale VK-Regel noch nicht bestätigt ist.';
        }
        return;
      }

      const pairs = [
        ['freestanding', '[data-mounting-price="freestanding"]'],
        ['overhang', '[data-mounting-price="overhang"]']
      ];
      pairs.forEach(([mode, selector]) => {
        const q = this.calculateMountingQuote(width, mode, false);
        const text = q?.ok ? `+ ${this.formatPrice(q.customerGrossSurcharge)}` : 'Preis prüfen';
        this.setText(selector, text);
      });
      const comboQ = this.calculateMountingQuote(width, 'freestanding', true);
      this.setText('[data-mounting-price="combo"]', comboQ?.ok ? `Gesamt + ${this.formatPrice(comboQ.customerGrossSurcharge)}` : 'Preis prüfen');
      const detail = this.root.querySelector('[data-mounting-technical]');
      if (detail && this.mountingQuote?.ok && this.mountingQuote.customerGrossSurcharge > 0) {
        const q = this.mountingQuote.quantity;
        detail.hidden = false;
        detail.textContent = this.mountingQuote.isSplit
          ? `${q.constructionRuns} Konstruktion${q.constructionRuns > 1 ? 'en' : ''}: ${q.beamPieces} Statikträger-Teilstücke, ${q.posts} zusätzliche 3-m-Pfosten. Mittlerer Pfosten je Lauf unter der Teilung.`
          : `${q.constructionRuns} Konstruktion${q.constructionRuns > 1 ? 'en' : ''}: ${q.beamPieces} Statikträger, ${q.posts} zusätzliche 3-m-Pfosten.`;
      } else if (detail) {
        detail.hidden = true;
      }
    }

    renderEngineDebug(quote, mountingQuote, ledQuote, staticsQuote, sideQuotes = {}) {
      const box = this.root.querySelector('[data-engine-debug]');
      if (!box) return;
      const enabled = this.root.dataset.showEngineDebug === 'true';
      box.hidden = !enabled;
      if (!enabled) return;

      if (!quote?.ok) {
        this.setText('[data-engine-band]', 'Keine Preisstufe');
        this.setText('[data-engine-list]', '–');
        this.setText('[data-engine-ek]', '–');
        this.setText('[data-engine-gross]', '–');
        this.setText('[data-engine-margin]', '–');
      } else {
        this.setText('[data-engine-band]', `${this.formatMm(quote.widthBand)} × ${this.formatMm(quote.depthBand)} mm`);
        this.setText('[data-engine-list]', this.formatMoney2(quote.vdListNet));
        this.setText('[data-engine-ek]', this.formatMoney2(quote.bekEkNet));
        this.setText('[data-engine-gross]', this.formatPrice(quote.customerGross));
        this.setText('[data-engine-margin]', `${quote.rawMarginPct.toFixed(1).replace('.', ',')} %`);
      }

      if (mountingQuote?.ok && mountingQuote.customerGrossSurcharge > 0) {
        this.setText('[data-engine-mounting]', mountingQuote.label);
        this.setText('[data-engine-mounting-list]', this.formatMoney2(mountingQuote.vdListNet));
        this.setText('[data-engine-mounting-ek]', this.formatMoney2(mountingQuote.bekEkNet));
        this.setText('[data-engine-mounting-gross]', this.formatPrice(mountingQuote.customerGrossSurcharge));
        this.setText('[data-engine-mounting-margin]', `${mountingQuote.rawMarginPct.toFixed(1).replace('.', ',')} %`);
        const q = mountingQuote.quantity;
        this.setText('[data-engine-mounting-parts]', `${q.beamPieces} Trägerteil(e) · ${this.formatNumber(q.beamTotalM, 2)} m Träger · ${this.formatNumber(q.fasciaTotalM, 2)} m Blende · ${q.posts} Pfosten à ${this.formatNumber(q.postLengthM, 0)} m`);
      } else {
        this.setText('[data-engine-mounting]', 'Wandmontage');
        this.setText('[data-engine-mounting-list]', '0,00 €');
        this.setText('[data-engine-mounting-ek]', '0,00 €');
        this.setText('[data-engine-mounting-gross]', 'inklusive');
        this.setText('[data-engine-mounting-margin]', '–');
        this.setText('[data-engine-mounting-parts]', 'Keine Zusatzkonstruktion');
      }

      if (ledQuote?.ok) {
        this.setText('[data-engine-led]', ledQuote.label);
        this.setText('[data-engine-led-list]', this.formatMoney2(ledQuote.vdListNet));
        this.setText('[data-engine-led-ek]', this.formatMoney2(ledQuote.bekEkNet));
        this.setText('[data-engine-led-gross]', ledQuote.customerGrossSurcharge ? this.formatPrice(ledQuote.customerGrossSurcharge) : 'inklusive');
        this.setText('[data-engine-led-margin]', ledQuote.customerGrossSurcharge ? `${ledQuote.rawMarginPct.toFixed(1).replace('.', ',')} %` : '–');
      }
      if (staticsQuote?.ok) {
        this.setText('[data-engine-statics]', staticsQuote.label);
        this.setText('[data-engine-statics-list]', this.formatMoney2(staticsQuote.vdListNet));
        this.setText('[data-engine-statics-ek]', this.formatMoney2(staticsQuote.bekEkNet));
        this.setText('[data-engine-statics-gross]', staticsQuote.customerGrossSurcharge ? this.formatPrice(staticsQuote.customerGrossSurcharge) : 'inklusive');
        this.setText('[data-engine-statics-margin]', staticsQuote.customerGrossSurcharge ? `${staticsQuote.rawMarginPct.toFixed(1).replace('.', ',')} %` : '–');
      }

      const frontQ = sideQuotes.front;
      this.setText('[data-engine-sg23-front-layout]', frontQ?.ok ? `${frontQ.layoutLabel} · ${frontQ.postCount} Pfosten · je Feld ca. ${this.formatMm(Math.round(frontQ.fieldWidthMm))} mm` : '–');
      this.setText('[data-engine-sg23-front-list]', frontQ?.ok ? this.formatMoney2(frontQ.vdListNet) : '–');
      this.setText('[data-engine-sg23-front-ek]', frontQ?.ok ? this.formatMoney2(frontQ.bekEkNet) : '–');
      this.setText('[data-engine-sg23-front-gross]', frontQ?.ok ? this.formatPrice(frontQ.customerGross) : '–');

      const sideQ = sideQuotes.left?.ok ? sideQuotes.left : sideQuotes.right?.ok ? sideQuotes.right : null;
      const partialSideQ = sideQuotes.left?.partialCustomerGross ? sideQuotes.left : sideQuotes.right?.partialCustomerGross ? sideQuotes.right : null;
      this.setText('[data-engine-side-sg23]', sideQ?.sg23?.ok ? `${sideQ.sg23.layoutLabel} · ${this.formatPrice(sideQ.sg23.customerGross)}` : (partialSideQ?.sg23?.ok ? `${partialSideQ.sg23.layoutLabel} · ${this.formatPrice(partialSideQ.sg23.customerGross)}` : '–'));
      this.setText('[data-engine-side-wedge]', this.isSkyView() ? 'nicht erforderlich' : (sideQ?.wedge?.ok ? `${sideQ.wedge.layoutLabel} · ${this.formatPrice(sideQ.wedge.customerGross)}` : 'Keilmaße fehlen'));
      this.setText('[data-engine-side-wedge-area]', this.isSkyView() ? '–' : (sideQ?.wedge?.ok ? `${this.formatNumber(sideQ.wedge.glassAreaSqm, 2)} m²` : '–'));
      this.setText('[data-engine-side-total]', sideQ?.ok ? this.formatPrice(sideQ.customerGross) : '–');

      const flags = this.root.querySelector('[data-engine-flags]');
      if (flags) {
        flags.innerHTML = '';
        const sideFlags = [sideQuotes.front, sideQuotes.left, sideQuotes.right].flatMap((q) => q?.flags || q?.sg23?.flags || []);
        const allFlags = [...(quote?.flags || []), ...(mountingQuote?.flags || []), ...(ledQuote?.flags || []), ...(staticsQuote?.flags || []), ...sideFlags];
        if (!quote?.ok) allFlags.unshift({ message: `${this.productMeta().short}-Basispreis konnte für diese Maße nicht berechnet werden.` });
        allFlags.forEach((flag) => {
          const item = document.createElement('div');
          item.className = 'bek-engine-debug__flag';
          item.textContent = flag.message;
          flags.appendChild(item);
        });
      }
    }

    formatMm(value) {
      const n = Number(String(value).replace(/\D/g, ''));
      return Number.isFinite(n) ? new Intl.NumberFormat(this.locale).format(n) : value;
    }

    renderReview(data) {
      const map = {
        product: data.productName || this.productMeta().name,
        dimensions: `${this.formatMm(data.width)} × ${this.formatMm(data.depth)} mm`,
        mounting: data.mounting,
        color: data.color,
        glass: data.glass,
        led: data.led,
        statics: data.statics,
        sides: data.sides.length ? data.sides.join(', ') : 'Keine Seitenwände',
        price: data.priceText
      };
      Object.entries(map).forEach(([key, value]) => this.setText(`[data-review-${key}]`, value));

      this.setText('[data-review-base-label]', data.productCode === 'SKYVIEW' ? 'SkyView Grunddach' : 'TDS Grunddach');
      this.setText('[data-review-base-price]', this.formatPrice(this.basePrice));
      this.setText('[data-review-mounting-label]', data.mounting);
      this.setText('[data-review-mounting-price]', data.mountingPrice ? `+${this.formatPrice(data.mountingPrice)}` : 'inklusive');
      this.setText('[data-review-led-label]', data.led);
      this.setText('[data-review-led-price]', data.ledPrice ? `+${this.formatPrice(data.ledPrice)}` : 'inklusive');
      this.setText('[data-review-statics-label]', data.statics);
      this.setText('[data-review-statics-price]', data.staticsPrice ? `+${this.formatPrice(data.staticsPrice)}` : 'inklusive');
      this.setText('[data-review-front-price]', data.frontPending ? 'Preis folgt' : (data.frontPrice ? `+${this.formatPrice(data.frontPrice)}` : 'inklusive'));
      this.setText('[data-review-left-price]', data.leftPending ? (data.productCode === 'SKYVIEW' ? 'Preis prüfen' : 'Keilmaß fehlt') : (data.leftPrice ? `+${this.formatPrice(data.leftPrice)}` : 'inklusive'));
      this.setText('[data-review-right-price]', data.rightPending ? (data.productCode === 'SKYVIEW' ? 'Preis prüfen' : 'Keilmaß fehlt') : (data.rightPrice ? `+${this.formatPrice(data.rightPrice)}` : 'inklusive'));

      const toggles = [
        ['[data-review-front-row]', data.frontSelected],
        ['[data-review-left-row]', data.leftSelected],
        ['[data-review-right-row]', data.rightSelected]
      ];
      toggles.forEach(([selector, show]) => {
        this.root.querySelectorAll(selector).forEach((el) => { el.hidden = !show; });
      });
      this.setText('[data-review-total-note]', data.technicalBlocked
        ? 'inkl. 19 % MwSt. · technische Prüfung vor Bestellung erforderlich · kostenlose Lieferung'
        : (data.hasPendingSidePrice
          ? 'inkl. 19 % MwSt. · mindestens eine gewählte Seitenwand noch nicht vollständig bepreist · kostenlose Lieferung'
          : 'inkl. 19 % MwSt. · kostenlose Lieferung'));
    }

    configStorageKey(id) {
      return `bek_roof_config_${id}`;
    }

    generateConfigId() {
      const productCode = this.currentProductCode();
      if (this.currentConfigId && this.currentConfigSystem === productCode) return this.currentConfigId;
      this.currentConfigId = null;
      this.currentConfigSystem = productCode;
      const now = new Date();
      const y = now.getFullYear();
      const m = String(now.getMonth() + 1).padStart(2, '0');
      const d = String(now.getDate()).padStart(2, '0');
      let token = '';
      if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
        const bytes = new Uint8Array(4);
        window.crypto.getRandomValues(bytes);
        token = Array.from(bytes, (value) => value.toString(36).padStart(2, '0')).join('').slice(0, 8).toUpperCase();
      } else {
        token = Math.random().toString(36).slice(2, 10).toUpperCase();
      }
      const prefix = productCode === 'SKYVIEW' ? 'BEK-SKY' : 'BEK-TDS';
      this.currentConfigId = `${prefix}-${y}${m}${d}-${token}`;
      return this.currentConfigId;
    }

    quoteSnapshot(quote) {
      if (!quote) return null;
      const keys = [
        'ok', 'label', 'vdListNet', 'bekEkNet', 'customerGross', 'customerGrossSurcharge',
        'rawMarginPct', 'widthBand', 'depthBand', 'heightBand', 'layoutLabel', 'fieldCount',
        'postCount', 'supportCount', 'rafterCount', 'fieldWidthMm', 'glassAreaSqm', 'partialCustomerGross',
        'productCode', 'productLabel', 'cover', 'coverLabel', 'coverKind', 'error'
      ];
      const snapshot = {};
      keys.forEach((key) => {
        if (quote[key] !== undefined) snapshot[key] = quote[key];
      });
      if (quote.quantity) snapshot.quantity = quote.quantity;
      if (quote.sg23) snapshot.sg23 = this.quoteSnapshot(quote.sg23);
      if (quote.wedge) snapshot.wedge = this.quoteSnapshot(quote.wedge);
      if (quote.fieldQuote) snapshot.fieldQuote = this.quoteSnapshot(quote.fieldQuote);
      return snapshot;
    }

    currentSelectionData() {
      const product = this.productMeta();
      const isSky = product.code === 'SKYVIEW';
      const front = Boolean(this.root.querySelector('[data-side-input="front"]')?.checked);
      const left = Boolean(this.root.querySelector('[data-side-input="left"]')?.checked);
      const right = Boolean(this.root.querySelector('[data-side-input="right"]')?.checked);
      const sides = [];
      if (front) sides.push(Number(this.frontQuote?.fieldCount || 1) > 1 ? `Front SG23 (${this.frontQuote.fieldCount} Felder)` : 'Front SG23');
      if (left) sides.push(isSky ? 'Links SG23' : 'Links komplett');
      if (right) sides.push(isSky ? 'Rechts SG23' : 'Rechts komplett');
      const wedgeLowRaw = this.root.querySelector('[name="wedge_low"]')?.value ?? '';
      const wedgeHighRaw = this.root.querySelector('[name="wedge_high"]')?.value ?? '';
      const colorValue = this.root.querySelector('[name="color"]:checked')?.value || '7016';
      return {
        productCode: product.code,
        productName: product.name,
        roofForm: product.roofLabel,
        width: this.inputValue('width', '6000'),
        depth: this.inputValue('depth', isSky ? '3500' : '4000'),
        mounting: this.selectedLabel('mounting', 'Wandmontage'),
        mountingValue: this.root.querySelector('[name="mounting"]:checked')?.value || 'wall',
        combo: isSky ? false : Boolean(this.root.querySelector('[name="mounting_combo"]')?.checked),
        color: this.selectedLabel('color', 'RAL 7016 Anthrazit'),
        colorValue,
        glass: this.selectedLabel('glass', 'VSG 8 mm klar'),
        glassValue: this.root.querySelector('[name="glass"]:checked')?.value || 'clear',
        led: this.selectedLabel('led', 'Ohne LED'),
        ledValue: this.root.querySelector('[name="led"]:checked')?.value || 'none',
        statics: this.selectedLabel('statics', 'Vereinfachter Nachweis'),
        staticsValue: this.root.querySelector('[name="statics"]:checked')?.value || 'simple',
        sides,
        priceText: this.formatPrice(this.price()),
        frontSelected: front,
        leftSelected: left,
        rightSelected: right,
        sgHeight: Number(this.inputValue('sg_height', this.root.dataset.sg23DefaultHeight || '2300')),
        sgGlassValue: this.root.querySelector('[name="sg_glass"]:checked')?.value || 'clear',
        wedgeLow: isSky || wedgeLowRaw === '' ? null : Number(wedgeLowRaw),
        wedgeHigh: isSky || wedgeHighRaw === '' ? null : Number(wedgeHighRaw),
        technicalBlocked: this.blockingTechnicalFlags().length > 0,
        technicalFlags: this.blockingTechnicalFlags()
      };
    }

    buildConfigurationPayload(data = this.currentSelectionData()) {
      const id = this.generateConfigId();
      const photoFiles = Array.from(this.root.querySelectorAll('[data-bek-photo-input]'))
        .map((input) => input.files && input.files[0] ? {
          label: input.dataset.photoLabel || '',
          fileName: input.files[0].name,
          type: input.files[0].type || '',
          size: Number(input.files[0].size || 0)
        } : null)
        .filter(Boolean);
      const notes = this.root.querySelector('[name="photo_notes"]')?.value || '';
      const productCode = data.productCode || this.currentProductCode();
      const productName = data.productName || this.productMeta(productCode).name;
      const isSky = productCode === 'SKYVIEW';
      return {
        schemaVersion: 'BEK_ROOF_ORDER_PAYLOAD_V1',
        engineVersion: 'M11.2.1.1-UNIFIED-ROOF-ENGINE',
        product: { code: productCode, name: productName, configurator: 'TERRASSENDACH_UNIFIED' },
        configurationId: id,
        generatedAt: new Date().toISOString(),
        currency: this.currency,
        locale: this.locale,
        customerSelection: {
          productCode,
          widthMm: Number(data.width),
          depthMm: Number(data.depth),
          mounting: isSky ? 'wall' : data.mountingValue,
          mountingCombo: isSky ? false : Boolean(data.combo),
          color: `RAL ${data.colorValue || '7016'}`,
          glass: data.glassValue,
          cover: data.glassValue,
          led: data.ledValue,
          statics: data.staticsValue,
          sg23HeightMm: Number(data.sgHeight),
          sg23Glass: data.sgGlassValue,
          wedgeLowMm: isSky || data.wedgeLow === null ? null : Number(data.wedgeLow),
          wedgeHighMm: isSky || data.wedgeHigh === null ? null : Number(data.wedgeHigh),
          sides: {
            front: Boolean(data.frontSelected),
            left: Boolean(data.leftSelected),
            right: Boolean(data.rightSelected)
          }
        },
        display: {
          product: productName,
          roofForm: data.roofForm || this.productMeta(productCode).roofLabel,
          mounting: data.mounting,
          color: data.color,
          glass: data.glass,
          cover: data.glass,
          led: data.led,
          statics: data.statics,
          sides: data.sides,
          totalGross: Number(this.price()),
          totalGrossText: data.priceText || this.formatPrice(this.price()),
          vatPct: Number(this.root.dataset.vatPct || 19),
          shippingIncluded: true,
          shippingGross: 0,
          shippingLabel: 'Kostenlose BEK Lieferung',
          technicalReviewRequired: Boolean(data.technicalBlocked)
        },
        delivery: {
          schemaVersion: 'BEK_DELIVERY_V1',
          countryCode: 'DE',
          requestedMethod: 'FREE_STANDARD',
          requestedFulfillment: 'BEK_DELIVERY',
          clientShippingGross: 0,
          clientShippingIsAdvisory: true
        },
        quotes: {
          base: this.quoteSnapshot(this.baseQuote),
          mounting: this.quoteSnapshot(this.mountingQuote),
          led: this.quoteSnapshot(this.ledQuote),
          statics: this.quoteSnapshot(this.staticsQuote),
          front: this.quoteSnapshot(this.frontQuote),
          left: this.quoteSnapshot(this.leftQuote),
          right: this.quoteSnapshot(this.rightQuote)
        },
        technicalReview: {
          required: Boolean(data.technicalBlocked),
          flags: Array.isArray(data.technicalFlags) ? data.technicalFlags : []
        },
        photoCheck: {
          selectedFiles: photoFiles,
          filesUploadedToServer: false,
          notes
        },
        security: {
          clientPriceIsAdvisory: true,
          serverMustRecalculate: true,
          serverMustDetermineDelivery: true,
          noApiSecretsInPayload: true
        }
      };
    }

    isOrderPayloadComplete(payload = this.lastPayload) {
      if (!payload || !this.baseQuote?.ok || !this.validateMeasurements(false)) return false;
      const selection = payload.customerSelection || {};
      const productCode = String(payload?.product?.code || selection.productCode || '').toUpperCase();
      if (!['TDS', 'SKYVIEW'].includes(productCode)) return false;
      if (payload?.technicalReview?.required || this.blockingTechnicalFlags().length) return false;
      const sides = selection.sides || {};
      if (!Number.isFinite(selection.widthMm) || !Number.isFinite(selection.depthMm)) return false;
      if (productCode === 'TDS' && (sides.left || sides.right) && (!Number.isFinite(selection.wedgeLowMm) || !Number.isFinite(selection.wedgeHighMm))) return false;
      if (sides.front && !this.frontQuote?.ok) return false;
      if (sides.left && !this.leftQuote?.ok) return false;
      if (sides.right && !this.rightQuote?.ok) return false;
      return true;
    }

    renderOrderBridgeState() {
      const button = this.root.querySelector('[data-bek-order]');
      if (!button) return;
      const complete = this.isOrderPayloadComplete(this.lastPayload);
      const technicalBlocked = this.blockingTechnicalFlags().length > 0;
      button.disabled = !complete;
      button.textContent = technicalBlocked ? 'Technische Prüfung erforderlich' : `${this.orderButtonLabel} →`;
      button.title = technicalBlocked
        ? 'Für dieses SkyView-Maß sind zusätzliche Verstärkungsbauteile erforderlich. Ein automatischer Checkout bleibt gesperrt, bis die zentrale Preisregel bestätigt ist.'
        : (!complete
          ? 'Bitte zuerst alle Pflichtmaße und gewählten Seitenwände vollständig ausfüllen.'
          : (!this.orderBridgeEnabled || !this.orderBridgeEndpoint
            ? 'Bestellfunktion ist derzeit nicht verfügbar. Bitte kontaktieren Sie BEK.'
            : 'Konfiguration serverseitig prüfen und sichere Kasse öffnen.'));
    }

    showOrderStatus(message, type = 'info') {
      const status = this.root.querySelector('[data-order-status]');
      if (!status) return;
      status.textContent = message;
      status.dataset.statusType = type;
    }

    saveConfiguration() {
      const payload = this.buildConfigurationPayload();
      try {
        localStorage.setItem(this.configStorageKey(payload.configurationId), JSON.stringify(payload));
        localStorage.setItem('bek_roof_last_config_id', payload.configurationId);
        if (payload.product?.code === 'TDS') localStorage.setItem('bek_tds_last_config_id', payload.configurationId);
        this.lastPayload = payload;
        this.showOrderStatus(`Konfiguration gespeichert: ${payload.configurationId}`, 'success');
      } catch (error) {
        this.showOrderStatus('Konfiguration konnte in diesem Browser nicht gespeichert werden.', 'error');
      }
    }

    resolveOrderBridgeEndpoint() {
      if (!this.orderBridgeEndpoint || !this.orderBridgeEndpoint.startsWith('/') || this.orderBridgeEndpoint.startsWith('//')) return null;
      try {
        const url = new URL(this.orderBridgeEndpoint, window.location.origin);
        return url.origin === window.location.origin ? url.href : null;
      } catch (error) {
        return null;
      }
    }

    async submitOrderBridge(button) {
      const payload = this.buildConfigurationPayload();
      this.lastPayload = payload;
      if (!this.isOrderPayloadComplete(payload)) {
        if (this.blockingTechnicalFlags().length) {
          this.showOrderStatus('Für dieses SkyView-Maß ist vor dem Checkout eine technische Prüfung erforderlich. Bitte nutzen Sie den Foto-Check oder kontaktieren Sie BEK.', 'error');
        } else {
          this.showOrderStatus('Bitte zuerst alle Pflichtmaße und gewählten Seitenwände vollständig ausfüllen.', 'error');
        }
        return;
      }

      if (!this.orderBridgeEnabled) {
        this.showOrderStatus('Die sichere Bestellfunktion ist derzeit nicht verfügbar. Bitte kontaktieren Sie BEK.', 'error');
        return;
      }

      const endpoint = this.resolveOrderBridgeEndpoint();
      if (!endpoint) {
        this.showOrderStatus('Bestellbrücke ist aktiviert, aber der Endpunkt ist ungültig. Erlaubt ist nur ein relativer Pfad auf diesem Shop.', 'error');
        return;
      }

      const oldText = button.textContent;
      button.disabled = true;
      button.textContent = 'Wird geprüft …';
      this.showOrderStatus('Ihre Konfiguration wird serverseitig geprüft …', 'info');
      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok) {
          if (response.status === 409 && result.error === 'PRICE_MISMATCH' && Number.isFinite(Number(result.serverGross))) {
            throw new Error(`Preisprüfung gestoppt: Serverpreis ${this.formatPrice(Number(result.serverGross))}. Bitte Preisverwaltung mit der Server-Bridge synchronisieren.`);
          }
          throw new Error(result.message || result.error || `HTTP ${response.status}`);
        }
        if (!result.checkoutUrl) throw new Error('Checkout-URL fehlt in der Serverantwort.');
        if (Number.isFinite(Number(result.serverGross))) {
          this.showOrderStatus(`Serverpreis geprüft: ${this.formatPrice(Number(result.serverGross))} · Lieferung kostenlos. Shopify-Checkout wird geöffnet …`, 'success');
        } else {
          this.showOrderStatus('Preis serverseitig geprüft. Shopify-Checkout wird geöffnet …', 'success');
        }
        const checkout = new URL(result.checkoutUrl, window.location.origin);
        if (!/^https?:$/.test(checkout.protocol)) throw new Error('Ungültige Checkout-URL.');
        window.location.assign(checkout.href);
      } catch (error) {
        button.disabled = false;
        button.textContent = oldText;
        this.showOrderStatus(`Bestellübergabe fehlgeschlagen: ${error.message}`, 'error');
      }
    }

    updatePhotoCard(input) {
      const card = input.closest('.bek-photo-card');
      if (!card) return;
      const status = card.querySelector('[data-photo-status]');
      const preview = card.querySelector('.bek-photo-card__preview');
      const file = input.files && input.files[0];
      card.classList.toggle('has-photo', Boolean(file));
      if (status) status.textContent = file ? file.name : 'Noch kein Foto';
      if (!preview) return;
      const old = preview.querySelector('img');
      if (old) old.remove();
      if (file && file.type && file.type.startsWith('image/')) {
        const image = document.createElement('img');
        image.alt = input.dataset.photoLabel || 'Ausgewähltes Foto';
        image.src = URL.createObjectURL(file);
        image.onload = () => URL.revokeObjectURL(image.src);
        preview.appendChild(image);
      }
    }

    updateUploadStatus(input) {
      const status = this.root.querySelector('[data-upload-status]');
      if (!status) return;
      const count = input.files ? input.files.length : 0;
      status.textContent = count
        ? `${count} Datei${count === 1 ? '' : 'en'} ausgewählt – nur DEV-Vorschau.`
        : 'Noch keine Dateien ausgewählt.';
    }
  }

  const init = () => {
    document.querySelectorAll('[data-bek-roof-configurator], [data-bek-tds-configurator]').forEach((root) => {
      if (!root.dataset.bekInitialized) {
        root.dataset.bekInitialized = 'true';
        new BekRoofConfigurator(root);
      }
    });
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
